export class BillEntryConstants {
  static readonly BAD_CHARACTERS = '{}[]^"~'; // Name 2, Remarks, Commodity description, and others
  static readonly BAD_CHARACTERS_PLUS = '{}[]^~“$:'; // Address, City
  static readonly NAME_BAD_CHARACTERS = '{}[]^"~%'; // Name 1
  static readonly SRN_BAD_CHARACTERS = '{}[]^"~$:,&'; // SRNs
  static readonly LOCAL_STORAGE_KEY = 'BillEntry.Bill';
}
